import React from 'react';
import {observable, makeObservable} from 'mobx';
import {observer} from 'mobx-react';
import s from '../s';
import * as emitter from '../../global/emitter';

declare const collapse: {
    init: () => void;
};

type Props = {
    toggleExpandable: (e: React.KeyboardEvent<HTMLDivElement>, id: string) => void;
};

@observer
export default class Yotpo extends React.Component<Props> {
    @observable init: boolean = false;
    @observable yotpo_success: boolean = false;

    constructor(props: Props) {
        super(props);
        makeObservable(this);
    }

    abForceUpdate = async () => this.forceUpdate();

    componentDidMount(): void {
        emitter.eventEmitter.subscribe(emitter.EventType.AB, 'ab', this.abForceUpdate);
        setTimeout(function () {
            var e = document.createElement('script');
            e.type = 'text/javascript';
            e.defer = true;
            e.src = '//staticw2.yotpo.com/H8vQ6ytRf3Uo0eAAlJJh85FR61IeET7EXRvzKasQ/widget.js';
            var t = document.getElementsByTagName('script')[0];
            t.parentNode?.insertBefore(e, t);
        }, 1500);
    }

    componentDidUpdate() {
        if (!this.init) {
            this.init = true;
            collapse.init();
        }
    }

    render() {
        if (!s.ready) {
            return;
        }

        if (!s.pcs.is_caf) {
            return (
                <div id="prod-reviews">
                    <div
                        id="prod-reviews-click"
                        className="prod-sub-header toggle-bs"
                        role="button"
                        tabIndex={0}
                        data-bs-toggle="collapse"
                        data-bs-target="#yotpo-main"
                        aria-expanded={false}
                        aria-controls="yotpo-main"
                        onKeyDown={e => this.props.toggleExpandable(e, 'prod-reviews-click')}
                    >
                        Customer Reviews
                    </div>
                    <div
                        id="yotpo-main"
                        className={`show collapse`}
                    >
                        <div
                            className="yotpo yotpo-main-widget"
                            id="divYotpo"
                            data-product-id={s.prod.ProductID}
                            data-name={s.ui.product_title}
                            data-currency="$"
                            data-price={s.ui.price}
                            data-url={s.si.URL}
                            data-image-url={s.prod.CustomizationMethod > 1 ? `https://${s.Portal.IMGDomain}/i/${s.prod.ProductID}_220_250.png` : `${s.prod.Image_Thumb}`}
                        />
                    </div>
                </div>
            );
        } else {
            return;
        }
    }
}
